// This hook checks if section is vissible and scrolled from the top, so is alligble for a sticky element

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import throttle from 'lodash/throttle';
import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';

export const useCheckSectionIsScrolled = (
  wrapperRef, stickyHeaderHeight, bottomOffset = 'bottom',
) => {
  const activeMQ = useSelector(selectActiveMQ);
  const [isSectionScrolled, setIsSectionScrolled] = useState(false);

  const calculateBottomOffsetValue = (bottomOffset) => {
    if (bottomOffset === 'top') return `-${stickyHeaderHeight}px`;
    if (bottomOffset === 'bottom') return '-100%';
    return bottomOffset; // otherwise should be a custom CSS unit value string (e.g., '-500px', '25%')
  };

  const bottomOffsetValue = calculateBottomOffsetValue(bottomOffset);

  useEffect(() => {
    const target = wrapperRef.current;

    if (!target) {
      setIsSectionScrolled(true);
      return isSectionScrolled;
    }

    let wrapperEntry;
    const throttledHandleWrapperScroll = throttle(handleWrapperScroll, 100);
    const options = { root: null, threshold: 0, rootMargin: `${bottomOffsetValue} 0px 0px 0px` };
    const observer = new IntersectionObserver(observerCallback, options);
    observer.observe(target);
    return () => {
      observer.disconnect();
      throttledHandleWrapperScroll.cancel();
      document.removeEventListener('scroll', throttledHandleWrapperScroll);
    };

    function observerCallback(entries) {
      [wrapperEntry] = entries;

      if (wrapperEntry.isIntersecting) {
        document.addEventListener('scroll', throttledHandleWrapperScroll);
        return;
      }

      document.removeEventListener('scroll', throttledHandleWrapperScroll);
      setIsSectionScrolled(false);
    }

    function handleWrapperScroll() {
      const { isIntersecting, target: wrapperNode } = wrapperEntry;
      setIsSectionScrolled(isIntersecting && wrapperNode.getBoundingClientRect().y < stickyHeaderHeight);
    }
  }, [stickyHeaderHeight, activeMQ]);

  return isSectionScrolled;
};
